import { render, staticRenderFns } from "./affiliateComission.vue?vue&type=template&id=5c6a63a2"
import script from "./affiliateComission.vue?vue&type=script&lang=js"
export * from "./affiliateComission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports